import styled from "styled-components";

const StyledTopCustomer = styled.div`
    &.frame-313293,
    &.frame-313293 * {
        box-sizing: border-box;
    }
    &.frame-313293 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313284 {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313288 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313310 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313286 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313327 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .heading-4-total-visitors {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .info-circle {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011363 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .ellipse-5 {
        border-radius: 50%;
        border-style: solid;
        border-color: #ff9900;
        border-width: 6px;
        flex-shrink: 0;
        width: 120px;
        height: 120px;
        position: absolute;
        left: 50%;
        translate: -50%;
        top: calc(50% - 96px);
        aspect-ratio: 1;
    }
    .image {
        border-radius: 9999px;
        flex-shrink: 0;
        width: 109px;
        height: 109px;
        position: relative;
        object-fit: cover;
        aspect-ratio: 1;
        top: 4px;
    }
    .frame-1000011362 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .kate-morrison {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-2-font-size, 24px);
        letter-spacing: var(--heading-2-letter-spacing, -0.005em);
        font-weight: var(--heading-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    ._3-275-orders {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;
export default function TopCustomer() {
    return (
        <StyledTopCustomer className="frame-313293">
            <div className="frame-313284">
                <div className="frame-313288">
                    <div className="frame-313310">
                        <div className="frame-313286">
                            <div className="frame-313327">
                                <div className="heading-4-total-visitors">YOUR TOP CUSTOMER</div>
                                <img className="info-circle" src="info-circle0.svg" alt="" />
                            </div>
                        </div>
                        <div className="frame-1000011363">
                            <div className="ellipse-5"></div>
                            <img
                                className="image"
                                src="https://bo7storage7testing.blob.core.windows.net/account-images/gant1_1731514547234.jpg"
                                alt=""
                            />
                            <div className="frame-1000011362">
                                <div className="kate-morrison">Kate Morrison</div>
                                <div className="_3-275-orders">3,275 orders</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledTopCustomer>
    );
}
